import * as React from 'react'
import { Link, Outlet, createRootRoute, useRouter } from '@tanstack/react-router'
import NotFoundPage from './_not-found'

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
})

export default function RootComponent() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--app-bg, transparent)' }}>
      <Outlet />
      {/* <TanStackRouterDevtools position="bottom-right" /> */}
    </div>
  )
}
